// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__KbG-q","containerItemsCenter":"Skeleton_containerItemsCenter__3rveU"};